import React from "react";
import { useForm } from "react-hook-form";
import { Box, Grid, Typography, Button, Paper } from "@mui/material";
import RFG from "../../libs/inputs/RFG";

export default function Form({
  title,
  companies = [],
  projects = [],
  users = [],
  defaultValues = {},
  onSubmit = () => { },
  onChange = () => { },
}) {
  const { handleSubmit, control } = useForm({ defaultValues, mode: "all" });

  return (
    <Box sx={{ p: 3 }}>
      <form
        onSubmit={handleSubmit((data) => {
          console.log("data submit", data);
          onSubmit(data);
        })}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <RFG
              name="title"
              label="Title"
              control={control}
              rules={{
                required: true,
                maxLength: 500
              }}
            >
              <input autoComplete="off" />
            </RFG>

            <RFG
              name="amount"
              label="Amount"
              control={control}
              rules={{
                required: true, maxLength: 500,
                pattern: {
                  value: /^[0-9]+$/, // only numbers
                  message: 'Numbers only'
                }
              }}
            >
              <input autoComplete="off" />
            </RFG>

            <RFG
              name="days"
              label="Days"
              control={control}
              rules={{
                required: true,
                maxLength: 30,
                pattern: {
                  value: /^[0-9]+$/, // only numbers
                  message: 'Numbers only'
                }
              }}
            >
              <input autoComplete="off" />
            </RFG>

            <RFG
              name="image_retention"
              label="Image Retention"
              control={control}
              rules={{
                required: true, maxLength: 12,
                pattern: {
                  value: /^[0-9]+$/, // only numbers
                  message: 'Numbers only'
                }
              }}
            >
              <input autoComplete="off" />
            </RFG>

            <RFG
              name="video_retention"
              label="Video Retention"
              control={control}
              rules={{
                required: true, maxLength: 12,
                pattern: {
                  value: /^[0-9]+$/, // only numbers
                  message: 'Numbers only'
                }
              }}
            >
              <input autoComplete="off" />
            </RFG>

            <RFG
              name="description"
              label="Description"
              control={control}
              rules={{ required: true, maxLength: 1000 }}
            >
              <input autoComplete="off" />
            </RFG>

            <RFG
              name="hybrid"
              label="AI Camera"
              control={control}
              rules={{
                required: true, maxLength: 12,
                pattern: {
                  value: /^[0-9]+$/, // only numbers
                  message: 'Numbers only'
                }
              }}
            >
              <input autoComplete="off" />
            </RFG>
          </Grid>

          <Grid item xs={12} md={6}>
            <RFG
              name="hd_ptz"
              label="HD PTZ Camera"
              control={control}
              rules={{
                required: true, maxLength: 12,
                pattern: {
                  value: /^[0-9]+$/, // only numbers
                  message: 'Numbers only'
                }
              }}
            >
              <input autoComplete="off" />
            </RFG>

            <RFG
              name="_4k_ptz"
              label="4K PTZ Camera"
              control={control}
              rules={{
                required: true, maxLength: 12,
                pattern: {
                  value: /^[0-9]+$/, // only numbers
                  message: 'Numbers only'
                }
              }}
            >
              <input autoComplete="off" />
            </RFG>

            <RFG
              name="_24mp"
              label="24 MP Camera"
              control={control}
              rules={{
                required: true, maxLength: 12,
                pattern: {
                  value: /^[0-9]+$/, // only numbers
                  message: 'Numbers only'
                }
              }}
            >
              <input autoComplete="off" />
            </RFG>

            <RFG
              name="_32mp"
              label="32 MP Camera"
              control={control}
              rules={{
                required: true, maxLength: 12,
                pattern: {
                  value: /^[0-9]+$/, // only numbers
                  message: 'Numbers only'
                }
              }}
            >
              <input autoComplete="off" />
            </RFG>

            <RFG
              name="_50mp"
              label="50 MP Camera"
              control={control}
              rules={{
                required: true, maxLength: 12,
                pattern: {
                  value: /^[0-9]+$/, // only numbers
                  message: 'Numbers only'
                }
              }}
            >
              <input autoComplete="off" />
            </RFG>

            <RFG
              name="_60mp"
              label="60 MP Camera"
              control={control}
              rules={{
                required: true, maxLength: 12,
                pattern: {
                  value: /^[0-9]+$/, // only numbers
                  message: 'Numbers only'
                }
              }}
            >
              <input autoComplete="off" />
            </RFG>
          </Grid>
        </Grid>

        <Box mt={3} display="flex" justifyContent="flex-end">
          <Button type="submit" className="btn-primary" color="primary">
            Save
          </Button>
        </Box>
      </form>
    </Box>

  );
}
